import React from 'react';

const Trends = ({ icon, text }) => {
  const renderTrendSwitch = () => {
    switch (+icon) {
      case 0:
        return <i className='lms-trend-static'></i>;
      case 1:
        return <i className='lms-trend-static'></i>;
      case 2:
        return <i className='lms-trend-up'></i>;
      case 3:
        return <i className='lms-trend-down'></i>;
      default:
        return null;
    }
  };

  return (
    <>
      <div
        className={`si-trends ${`si-trends--${
          +icon === 1 ? 'eq' : +icon === 3 ? 'down' : +icon === 2 ? 'up' : 'eq'
        }`}`}
      >
        {renderTrendSwitch()}
      </div>
      <div className='si-trends__text'>{text || '-'}</div>
    </>
  );
};

export default Trends;
